<template>
  <div class="thirdParty app-container" v-loading="loading">
    <div class="global-header-wrap">
      <h3>第三方服务配置</h3>
      <div class="thirdParty-header-right">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'thirdPartyAdd' })"
        >
          新增
        </button>
      </div>
    </div>
    <div class="thirdParty-main">
      <el-card class="thirdParty-main-left" :body-style="{ padding: '0px' }">
        <div slot="header">
          <div class="thirdParty-header">
            <span>类别</span>
          </div>
        </div>
        <div class="thirdParty-menu">
          <div style="flex:1;" v-bar>
            <div>
              <div
                v-for="item in groupData"
                :key="item.configType"
                class="thirdParty-menu-item"
                :class="{
                  menuActive: item.configType === currentConfigType
                }"
                @click="setRouterParams(item)"
              >
                <p class="omitText">
                  {{
                    item.configType === 'undefined' ? 'others' : item.configType
                  }}
                </p>
                <!-- <div class="thirdParty-btn">
                  <i
                    class="el-icon-delete"
                    @click.stop="showDelPopup(item)"
                  ></i>
                  <i class="el-icon-edit" @click.stop="showEditPopup(item)"></i>
                </div> -->
              </div>
            </div>
          </div>
          <!-- <button
            class="global-button-style"
            style="margin:0;"
            @click="showAddPopup"
          >
            <i class="el-icon-plus"></i>
          </button> -->
        </div>
      </el-card>
      <el-card class="app-table-container" :body-style="{ padding: '20px' }">
        <!-- <div slot="header">
        <div class="global-table-header">
          <div class="thirdParty-header-btn-left">
            <list-search ref="listSearch" @listSearchEvn="listSearchFun" />
          </div>
        </div>
      </div> -->
        <div class="global-body-wrap">
          <TableView
            :tableData="tableData"
            :tableProp="tableProp"
            handleWidth="200"
            :handleBtn="handleBtn"
            @tableHandle="tableHandle"
          />
        </div>
        <!-- <Pagination
          :pageSize="params.limit"
          :total="total"
          @pageNum="getPageNum"
        /> -->
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import listSearch from '@/components/listSearch'
import TableView from '@/components/tableView'
import Pagination from '@/components/pagination'
import syncUtils from '@/syncUtils'
export default {
  components: {
    listSearch,
    TableView,
    Pagination
  },
  computed: {
    ...mapGetters(['userInfo']),
    tableProp() {
      let tableProp = [
        {
          prop: 'content',
          label: '内容'
        },
        {
          prop: 'clusterLang',
          label: '语言'
        },
        {
          prop: 'configType',
          label: '配置类型'
        },
        {
          prop: 'key',
          label: 'Key'
        },
        {
          prop: 'configStatus',
          label: '当前状态'
        },
        {
          prop: 'createdAt',
          label: '创建时间'
        }
      ]
      return tableProp
    },
    handleBtn() {
      return [
        { style: 'checkDetailsBtn', type: 'edit', title: '编辑' },
        { style: 'delBtn', type: 'del', title: '删除' },
        { style: 'checkDetailsBtn', type: 'open', title: '启用' },
        { style: 'delBtn', type: 'close', title: '禁用' }
      ]
    }
  },
  data() {
    return {
      loading: false,
      ruleForm: {
        name: '',
        models: ''
      },
      params: {
        limit: 20,
        page: 1
      },
      groupData: [],
      originData: [],
      tableData: [],
      total: 0,
      currentItem: null,
      currentGroup: null,
      currentConfigType: ''
    }
  },
  methods: {
    async getList() {
      this.loading = true
      let opts = {
        dbName: `CloudConfig`,
        channels: `CloudConfig`
      }
      await syncUtils.pull(opts)
      let res = await syncUtils.getChannel(opts)
      this.groupData = this.$_.chain(res)
        .groupBy('configType')
        .toPairs()
        .map((item) => {
          return this.$_.zipObject(['configType', 'list'], item)
        })
        .value()
      console.log(this.groupData)
      if (!this.groupData.length) {
        this.loading = false
        return
      }
      if (!this.$route.query.t) {
        this.setRouterParams(this.groupData[0])
      } else {
        this.currentGroup = this.groupData.find(
          (item) => item.configType === this.$route.query.t
        )
        this.getCategoryDetails(this.currentGroup)
      }
      this.loading = false
    },

    setRouterParams(item) {
      this.$router.push({
        name: 'thirdPartyList',
        query: {
          t: item.configType
        }
      })
      this.getCategoryDetails(item)
    },

    getCategoryDetails(item) {
      this.currentGroup = item
      this.currentConfigType = item.configType
      this.originData = this.currentGroup.list
      this.cuttingCbData()
    },

    cuttingCbData() {
      this.total = this.originData.length
      this.tableData = this.originData.slice(
        (this.params.page - 1) * this.params.limit,
        this.params.page * this.params.limit
      )
    },

    tableHandle({ type, data }) {
      this.currentItem = data
      switch (type) {
        case 'edit':
          this.$router.push({
            name: 'thirdPartyAdd',
            query: { id: this.currentItem._id }
          })
          break
        case 'del':
          this.del()
          break
        case 'open':
        case 'close':
          this.update(type)
          break

        default:
          break
      }
    },

    async update(type) {
      await this.$confirm(
        type === 'open' ? '将启用此配置' : '将禁用此配置',
        '确定?',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          center: true
        }
      )
      try {
        this.currentItem.configStatus = this.currentItem.configStatus ? 0 : 1
        await this.$store.dispatch('updateServiceConfigItem', this.currentItem)
        this.$message({
          type: 'success',
          message: this.$t('commonMsg.success')
        })
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t('commonMsg.failure')
        })
      }
    },

    async del() {
      await this.$confirm('将删除此项配置', '确定删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        center: true
      })
      try {
        await this.$store.dispatch('delServiceConfigItem', this.currentItem)
        let idx = this.currentGroup.list.findIndex(
          (item) => item._id === this.currentItem._id
        )
        this.currentGroup.list.splice(idx, 1)
        this.getCategoryDetails(this.currentGroup)
        this.$message({
          type: 'success',
          message: this.$t('commonMsg.success')
        })
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t('commonMsg.failure')
        })
      }
    },

    listSearchFun(val) {
      if (val) {
        this.params.name = val
      } else {
        delete this.params.name
      }
      this.getList()
    },

    getPageNum(page) {
      this.params.page = page
      this.cuttingCbData()
    }
  },

  async mounted() {
    let res = await this.$http.getSyncToken({ userId: this.userInfo.id })
    this.$cookie.set(res.data.cookie_name, res.data.session_id)
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
.thirdParty {
  .thirdParty-main {
    flex: 1;
    display: flex;
    overflow: hidden;
    .thirdParty-main-left {
      margin: 20px 0 20px 20px;
      width: 250px;
      display: flex;
      flex-direction: column;
      .thirdParty-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      > .el-card__body {
        flex: 1;
        display: flex;
        overflow: hidden;
      }
      .thirdParty-menu {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .thirdParty-menu-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 5px;
          padding: 10px;
          cursor: pointer;
          > p {
            flex: 1;
          }
          &:hover {
            background: #f3f6f9;
            > .thirdParty-btn {
              display: block;
            }
          }
          .thirdParty-btn {
            display: none;
            > i {
              margin-left: 10px;
            }
          }
        }
        .menuActive {
          background: #f3f6f9;
        }
      }
    }
  }
}
</style>
